// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1voRh","filesListContainer":"PosDisputesFiles_filesListContainer__2dq2T","filesButton":"PosDisputesFiles_filesButton__1n-hQ"};